import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import UserRolesResource from '../../resources/userRolesMx'
import toastMixin from '../../mixins/toast'
import userGridColumns from '../users_grid/userGridColumns'

export default Vue.extend({
    data() {
        return {
            userRolesColumnDefs: [
                {
                    field: 'username',
                    editable: false,
                    sortable: true,
                    valueSetter: (params) => {
                        let resource = params.data.managers.user_id.resource
                        resource.set('username', params.newValue)
                    },
                    valueGetter: (params) => {
                        let userResource = params.data.managers.user_id.resource
                        return userResource.attributes.username
                    },
                },
                {
                    headerName: 'Role',
                    field: 'role_id',
                    editable: false,
                    sortable: true,
                    valueFormatter: (params) => {
                        if (!params || !params.value) return ''
                        switch (parseInt(params.value)) {
                            case 1:
                                return 'Superuser/Admin'

                            case 2:
                                return 'Payroll Supervisor'

                            case 3:
                                return 'Payroll'

                            case 4:
                                return 'Payroll Data Entry'

                            case 5:
                                return 'User'

                            case 6:
                                return 'I-9 Verifier'

                            default:
                                return 'Other/Error'
                        }
                    },
                    valueSetter: (params) => {
                        params.data.set('role_id', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.role_id
                    },
                },
                {
                    headerName: 'Access',
                    field: 'access',
                    editable: true,
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('access', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.access
                    },
                },
                {
                    headerName: 'Status',
                    field: 'status',
                    editable: true,
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('status', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.status
                    },
                },
                {
                    headerName: 'Role Time Updated',
                    field: 'time_updated',
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('time_updated', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.time_updated
                    },
                },
                {
                    headerName: 'Company',
                    field: 'company',
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('company', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.company
                    },
                },
                {
                    headerName: 'Entity',
                    field: 'entity',
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('entity', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.entity
                    },
                },
            ],
            userRolesRowData: [],
            userRolesResources: undefined,
        }
    },
    props: ['entityId'],
    mixins: [toastMixin],
    methods: {
        refreshUserRolesMxGrid() {
            this.fetchUserRoles(this.entityId)
        },
        async fetchUserRoles(entityId) {
            try {
                const pendingManagers = []
                const userRolesResourceResponses = await UserRolesResource.all({ entity_id: entityId })
                const userRoleResources = userRolesResourceResponses.map((userRoleResource) => {
                    let promise = userRoleResource.managers.user_id.resolve()
                    pendingManagers.push(promise)
                    return userRoleResource
                })

                Promise.all(pendingManagers)
                    .then(() => {
                        this.userRolesResources = this.userRolesRowData = userRoleResources
                    })
                    .catch(() => {
                        this.createToast('b-toaster-top-center', 'danger', true, 'Network Error', 'Error getting User Roles')
                    })
            } catch (error) {
                this.createToast('b-toaster-top-center', 'danger', true, 'Network Error', 'Error getting User Roles')
            }
        },
        save() {
            let promises = []
            this.userRolesResources.forEach((resource) => {
                let userResourceManager = resource.managers.user_id

                if (Object.keys(resource.changes).length) {
                    let userRolesResourcePromise = resource
                        .save()
                        .then((result) => {
                            if (result.response.status > 200 || result.response.status < 299) {
                                this.createToast('b-toaster-top-center', 'success', true, 'User Updated', 'User was updated')
                            }
                        })
                        .catch(() => {
                            this.createToast('b-toaster-top-center', 'danger', true, 'Update Error', 'The user was not updated')
                        })
                    promises.push(userRolesResourcePromise)
                }

                if (userResourceManager.resolved && Object.keys(userResourceManager.resource.changes).length) {
                    let userResourceSavePromise = userResourceManager.resource
                        .save()
                        .then((result) => {
                            if (result.response.status > 200 || result.response.status < 299) {
                                this.createToast('b-toaster-top-center', 'success', true, 'User Updated', 'User was updated')
                            }
                        })
                        .catch(() => {
                            this.createToast('b-toaster-top-center', 'danger', true, 'Update Error', 'The user was not updated')
                        })
                    promises.push(userResourceSavePromise)
                }
                return Promise.all(promises).then(() => undefined)
            })
        },
    },
    components: {
        AgGridVue,
    },
    watch: {
        entityId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchUserRoles(newVal)
            }
        },
    },
    beforeMount() {
        this.userRolesColumnDefs = [...this.userRolesColumnDefs, ...userGridColumns]
    },
    async mounted() {
        if (this.entityId) {
            this.fetchUserRoles(this.entityId)
        } else {
            const userRolesResource = await UserRolesResource.list()
            this.userRolesRowData = userRolesResource.resources
        }
    },
})
